import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { environment } from './../../../environments/environment';
import { Router, NavigationEnd } from "@angular/router";

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { filter } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { Auth0Service } from '../../authentication/auth0/auth0.service';
import { CommunicationService } from '../../shared/services/communication.service';
import { LoaderService } from '../../shared/services/loader.service';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  imgUrl = environment.imgUrl;
  dir = 'ltr';
  green: boolean = true;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  communicationServiceListener;
  isSidebar;
  isShow = false;

  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;
  @ViewChild('snav') sideNav: MatSidenav;

  constructor(
    private communicationService: CommunicationService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private router: Router,
    private auth0: Auth0Service,
    private loader: LoaderService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1025px)');
    this._mobileQueryListener = () => {
      return changeDetectorRef.detectChanges()};
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.loader.progressLoader.subscribe(state=>{
      setTimeout(()=>{
        this.isShow = state;
      },10)
    })
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.communicationServiceListener.unsubscribe();
  }
  ngAfterViewInit() {
    // This is for the topbar search
    (<any>$('.srh-btn, .cl-srh-btn')).on('click', function () {
      (<any>$('.app-search')).toggle(200);
    });

    this.router.events.pipe(
      filter((a, b) => b && a instanceof NavigationEnd)
    ).subscribe((_) => {
      if (!this.mobileQuery.matches) {
        this.sideNav.close()
      }
    })
    this.communicationService.showSidebar.subscribe(flag=>{
      this.isSidebar = flag;
      if(this.sideNav)
        this.hideShowSidebar();
    })
  }

  hideShowSidebar(){
    setTimeout(()=>{
      if(this.isSidebar)
        this.sideNav.open();
      else  
        this.sideNav.close();
    },0)
  }

  logout(){
    localStorage.clear();
    this.auth0.logout();
  }

  // Mini sidebar
}
